<template>
    <div class="nk-content nk-content-fluid">
        <div class="container-xl wide-lg">
            <div class="nk-content-body">
                <div class="nk-block-head">
                    <div class="row g-gs">
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <h3 class="nk-block-title page-title">My Team</h3>
                            <div class="nk-block-des text-soft">
                                <p>You have total {{rowCount}} team member.</p>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <div class="row g-gs">
                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <team-level-dropdown v-model="level" @input="getPage()" />
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                    <input v-model="search" type="text" class="form-control" placeholder="Type to search">
                                </div>
                            </div>
                            
                            
                        </div>
                    </div>

                    

                </div><!-- .nk-block-head -->
                <div class="nk-block">
                    <div class="row g-gs">
                        <div v-for="user in userList" :key="user.id" class="col-sm-6 col-lg-4">
                            <div class="card card-bordered">
                                <div class="card-inner">
                                    <div class="team">
                                        <div class="team-status " v-bind:class="user.isActive? 'bg-success text-white' : 'bg-danger text-white'"><em class="icon ni ni-check-thick"></em></div>

                                        <div class="user-card user-card-s2">
                                            <div class="user-avatar md bg-primary">
                                                <img src="/images/avatar/a-sm.jpg" alt="">
                                                <div class="status dot dot-lg dot-success"></div>
                                            </div>
                                            <div class="user-info">
                                                <h6>{{user.userName}}</h6>
                                            </div>
                                        </div>
                                        <div class="team-details">
                                            <p>{{user.date}}</p>
                                        </div>
                                        <ul class="team-statistics">
                                            <li><span>{{AmountFormat(user.earning)}}</span><span>Reference Earning</span></li>
                                        </ul>
                                        <div class="team-details">
                                            <p class="text-success">Active Package ${{user.packagePlanAmount}} ({{user.packagePlanCount}})</p>
                                        </div>
                                        <!--<div class="team-view">
                                            <a v-on:click="ViewTransaction(user.id)" href="javascript:void(0)" class="btn btn-round btn-outline-light btn-block"><span>View Earning History</span></a>
                                        </div>-->
                                    </div><!-- .team -->
                                </div><!-- .card-inner -->


                            </div><!-- .card -->
                        </div><!-- .col -->

                        <div class="card-inner">
                            <div class="nk-block-between-md g-3">
                                <div class="g">
                                    <div class="pagination justify-content-center justify-content-md-start">
                                        <div class="overflow-auto" v-on:click="getPage()">
                                            <b-pagination pills size="md" v-model="currentPage"
                                                          :total-rows="rowCount"
                                                          :per-page="10"
                                                          first-text="First"
                                                          prev-text="Previous"
                                                          next-text="Next"
                                                          last-text="Last"></b-pagination>
                                        </div>
                                    </div><!-- .pagination -->
                                </div>
                                <div class="g">
                                    <div class="pagination-goto d-flex justify-content-center justify-content-md-start gx-3 text-capitalize">
                                        <span v-if="currentPage===1 && rowCount === 0"> Showing 0 to 0 of 0 entries</span>
                                        <span v-else-if="currentPage===1 && rowCount < 10"> Showing {{currentPage}} to {{rowCount}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1 && rowCount >= 11  "> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage===1"> Showing {{currentPage}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage!==1 && currentPage!==pageCount"> Showing {{(currentPage*10)-9}} to {{currentPage*10}} of {{rowCount}} entries</span>
                                        <span v-else-if="currentPage === pageCount"> Showing {{(currentPage*10)-9}} to {{rowCount}} of {{rowCount}} entries</span>
                                    </div>
                                </div><!-- .pagination-goto -->
                            </div><!-- .nk-block-between -->
                        </div><!-- .card-inner -->
                    </div>
                </div><!-- .nk-block -->
            </div>
        </div>
        <team-bonus-history-modal :transactionList="transactionList" :show="show" v-if="show" @close="show=false" />

    </div>
</template>
<script>
    export default {
        name: 'signUp',
        data: function () {
            return {
                level: '',
                search: '',
                currentPage: 1,
                pageCount: '',
                rowCount: '',
                pageSize: '',

                show: false,
                loading: false,
                userList: [],
                transactionList: [],
            }
        },
        watch: {
            search: function (val) {
                this.GetData(val, 1);
            }
        },
        methods: {
            ViewTransaction: function (teamUserId) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get('/Contact/ViewTransaction?teamUserId=' + teamUserId, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.transactionList = response.data;
                        root.show = true;
                    }
                }).catch(error => {
                    console.log(error)
                });
            },
            
            AmountFormat: function (amount) {
                return '$'+parseFloat(amount).toFixed(4);
            },

            AddSignup: function () {
                this.$router.push('/NewUser')
            },


            getPage: function () {
                this.GetData(this.search, this.currentPage);
            },

            GetData: function (search, currentPage) {
                var root = this;
                var url = '/Contact/TeamList?searchTerm=' + search + '&pageNumber=' + currentPage + '&pageSize=' + this.pageSize + '&level=' + this.level;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }

                root.$https.get(url, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                        root.userList = response.data.results;
                        root.pageCount = response.data.pageCount;
                        root.rowCount = response.data.rowCount;
                    }
                }).catch(error => {
                    console.log(error)
                    root.$swal.fire({
                            icon: 'error',
                            type: 'error',
                            title: 'Error',
                            text: "Something Went Wrong",
                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });
                }).finally(() => root.loading = false);
            },

        },
        created: function () {

        },
        mounted: function () {
            this.GetData(this.search, 1);
        },
    }
</script>